import { useLang } from "../i18n";
import { useReveal } from "../hooks/useReveal";
import { Quote } from "lucide-react";

export default function Testimonials() {
  const { t } = useLang();
  const r = useReveal();
  return (
    <section data-testid="testimonials-section" className="relative bg-neutral-950 py-24 md:py-32 border-y border-white/10">
      <div className="container-x">
        <div ref={r} className="reveal mb-12">
          <p className="overline mb-4">{t.testimonials.overline}</p>
          <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl uppercase tracking-tighter leading-[0.95] max-w-3xl">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {t.testimonials.items.map((it, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-black border border-white/10 p-8 md:p-10 group hover:border-white/30 transition-colors"
            >
              <Quote
                className="w-7 h-7 mb-6"
                style={{ color: i === 0 ? "hsl(var(--coral))" : i === 1 ? "hsl(var(--mustard))" : "hsl(var(--teal))" }}
              />
              <blockquote className="font-editorial italic text-lg md:text-xl text-white/85 leading-snug">
                {it.q}
              </blockquote>
              <figcaption className="mt-6 text-xs uppercase tracking-[0.24em] text-white/55">
                {it.a}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
